import React, { useContext } from "react";
import { ObjectPropertyList } from "./ObjectPropertyList";
import { CITABLE_OBJECT_TYPES, OBJECT_PROPERTIES } from "../../../config";
import { objectType } from "../../page/components/ObjChooser";
import { SidePanel } from "../../panels/components/SidePanel";
import { AnnotationContext } from "../../annotation/components/Annotation/AnnotationServiceProvider";
import AnnotationEditor, {
  annotationToObj
} from "../../annotation/components/Annotation/AnnotationEditor";
import { deleteObject, saveObject } from "../../search/helpers";
import { useSearcher } from "../../search/components/SearcherContext";
import { useObjectState } from "./ObjectProvider";
import ObjectCitationPanel from "./ObjectCitationPanel";

const ObjectSidePanel = () => {
  const panels = [];
  const obj = useObjectState();
  const search = useSearcher();
  const {
    annotation,
    setAnnotation,
    isEditingAnnotation,
    saveAnnotation
  } = useContext(AnnotationContext);

  if (obj === null) {
    return null;
  }

  if (isEditingAnnotation(annotation)) {
    panels.push({
      active: true,
      key: "annotation-editor",
      title: "Edit Annotation",
      content: (
        <AnnotationEditor
          annotation={annotation}
          onValueChanged={v => {
            const textBody = annotation.body[1];
            textBody.value = v;
            setAnnotation({
              ...annotation,
              body: [annotation.body[0], textBody]
            });
          }}
          onFontSizeChanged={v => {
            const dataSetBody = annotation.body[0];
            dataSetBody.value.fontSize = v;
            setAnnotation({
              ...annotation,
              body: [dataSetBody, annotation.body[1]]
            });
          }}
          onLetterSpacingChanged={v => {
            const dataSetBody = annotation.body[0];
            dataSetBody.value.letterSpacing = v;
            setAnnotation({
              ...annotation,
              body: [dataSetBody, annotation.body[1]]
            });
          }}
          onMotivationChanged={v => {
            setAnnotation({
              ...annotation,
              motivation: v
            });
          }}
          onDelete={v => {
            setAnnotation(null);
            deleteObject(
              annotationToObj({ annotation: v, parent: obj }),
              search.credentials.token,
              result => {
                setAnnotation(null);
              }
            );
          }}
          onSave={v => {
            saveObject(
              annotationToObj({
                annotation: v,
                parent: obj
              }),
              search.credentials.token,
              result => {
                saveAnnotation(v);
                setAnnotation(null);
              }
            );
          }}
        />
      )
    });
  }

  const objType = objectType(obj);

  panels.push({
    key: "object-details",
    title: "Details",
    active: !isEditingAnnotation(annotation),
    content: <ObjectPropertyList properties={OBJECT_PROPERTIES} />
  });

  if (CITABLE_OBJECT_TYPES.indexOf(objType) !== -1) {
    panels.push({
      key: "object-citation",
      title: "Reference",
      content: <ObjectCitationPanel obj={obj} />,
      active: true
    });
  }

  if (objType === "container") {
    panels.push({
      key: "container-details",
      title: "Container",
      active: true,
      content: (
        <ObjectPropertyList
          properties={[
            {
              key: "NUMBER_OF_PAGES",
              label: "Number of Objects"
            }
          ]}
        />
      )
    });
  }

  return <SidePanel panels={panels} />;
};

export default ObjectSidePanel;
